<template>
    <div class="assignment">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon"></myBreadCrumb> -->
        <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog>
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Phiếu nghỉ phép
                <v-spacer></v-spacer> 
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <data-export v-model="exportDialog"></data-export>
                <v-btn v-if="selectedItems.length > 0" @click="bulkAccept" :loading="isBulkApproving" dark color="orange darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                    <v-icon left>mdi-check-all</v-icon> DUYỆT ĐÃ CHỌN ({{ selectedItems.length }})
                </v-btn>
                <v-btn @click="dialog.state=true" dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> <v-icon left>mdi-plus</v-icon> TẠO PHIẾU </v-btn>
            </v-card-title>
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <div class="d-flex align-center wrapper mx-2 my-2">
                        <month-picker width="7rem" v-model="month" label="Tháng" outlined dense></month-picker>
                    </div>
                    <v-text-field label="Ngày xét" outlined type="date" v-model="filters.execDate" hide-details dense
                    class="mx-2 my-2 flex-grow-0 flex-shrink-1" style="background-color: white;"
                    ></v-text-field>

                    <!-- start filtering -->
                    <v-text-field label="Mã phiếu" dense v-model="filters.code" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-shrink-1" style="background-color: white;" placeholder="DXNP..." ></v-text-field>
                        
                    <v-select label="Trạng thái" placeholder="Chọn" dense v-model="filters.status" outlined hide-details
                        :items="[
                            {text: 'Tất cả', value: -1},
                            {text: 'Phiếu mới', value: 0},
                            {text: 'Đã duyệt', value: 1},
                            {text: 'Từ chối', value: 2},
                        ]"
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px; background-color: white;" ></v-select>
 
                    <v-text-field label="Mã NS" placeholder="NS0000" dense v-model="filters.employeeCode" outlined hide-details persistent-placeholder
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="background-color: white;"></v-text-field>
                        
                    <v-text-field label="Tên NS" dense v-model="filters.employeeName" outlined hide-details persistent-placeholder placeholder="Tên Nhân Sự .. "
                        class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="background-color: white;"></v-text-field>
                        
                        
                    <v-autocomplete label="Phòng ban" clearable outlined :items="departments.map(x=>{
                            return {
                                text: x.name,
                                value: x.code
                            }
                        })" v-model="filters.departmentCode" dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 250px;background-color: white;"></v-autocomplete>

                    <!-- <v-text-field label="Tên phòng ban" dense v-model="filters.departmentName" outlined hide-details persistent-placeholder placeholder="TS00.."
                        class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 250px;"></v-text-field> -->
                    
                    <v-select label="Cả ngày/nửa ngày" outlined :items="[
                            {text: 'Tất cả', value: -1},
                            {text: 'Nửa ngày', value: 0.5},
                            {text: 'Cả ngày', value: 1},
                        ]" v-model="filters.leaveAmountType" dense hide-details
                        class="mx-2 my-2 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-select>

                    <v-select label="Loại phép" clearable outlined :items="leavePlans.map(x=>{
                            return {
                                text: x.code === 'TUAN1' ? x.name + ' (TUAN 1)' : x.code === 'TUAN2' ? x.name + ' (TUAN 2)': x.name,
                                value: x.code
                            }
                        })" v-model="filters.leavePlanCode" dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px;max-width: 300px;background-color: white;"></v-select>
                    <!-- <v-select label="Loại làm thêm" placeholder="Chọn" dense v-model="filters.overtimeTypeName" outlined hide-details persistent-placeholder
                            :items='overtimeTypes.map(x=>x.name)' clearable
                            class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px;max-width: 300px;"></v-select> -->
                        
                    <v-text-field label="Ngày áp dụng" type="date" clearable dense v-model="filters.from" outlined hide-details persistent-placeholder placeholder="Ngày áp dụng"
                        class="mx-2 my-2 flex-grow-0 flex-shrink-1" style="max-width: 200px;background-color: white;"></v-text-field>
                </div>
            </v-sheet>
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                     Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>
            <v-data-table
            v-model="selectedItems"
            show-select
            item-key="code"
            :mobile-breakpoint="0"
            height="600px" fixed-header
            :headers="headers"
            :items="items"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            :footer-props="{
                itemsPerPageOptions:[
                50, 100, 200
                ]
            }"
            >
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="item.status === 0" :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                </template>

                <template v-slot:[`item.employeeInfo`]="{item}">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.employeeName}}</div>
                    <div class="caption grey--text">{{item.employeeCode}}</div>
                </template>

                <template v-slot:[`item.from`]="{item}">
                    {{formatDate(item.from)}}
                </template>
                
                <template v-slot:[`item.processInfo`]="{item}">
                    <div style="line-height: 1.3;"><span class="grey--text caption">Gửi:</span> {{formatDate(item.sentDate)}}</div>
                    <div v-if="item.confirmBy" style="line-height: 1.3;"><span class="grey--text caption">Duyệt:</span> {{item.confirmBy}}</div>
                    <div v-if="item.confirmDate && item.status != 0" style="line-height: 1.3;"><span class="grey--text caption">Lúc:</span> {{formatDate(item.confirmDate)}}</div>
                </template>

                <template v-slot:[`item.actions`]="{item}" >
                    <!-- ********* Edit ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" color="green lighten-4" @click="accept(item)">
                        <v-icon left small>mdi-check-circle</v-icon> Duyệt
                    </v-btn>

                    <!-- ********* Xoa ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="decline(item)" >
                        <v-icon left small>mdi-close-circle</v-icon> Từ chối
                    </v-btn>

                    <!-- ********* Undo ****** -->
                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" v-if="item.status != 0" color="blue-grey lighten-4" @click="undo(item)" >
                        <v-icon left small>mdi-undo</v-icon> Hoàn tác
                    </v-btn>
                    
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="remove(item)" v-if="item.status == 0">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </template>

                <template v-slot:[`item.leaveAmountType`]="{item}">
                    {{ item.leaveAmountType }} {{ !!item.halfShiftType ? ' - '+ item.halfShiftType: '' }}
                </template> 


                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="$helper.formatStatus(item.status).color" small dark style="width: 100px; justify-content: center;">
                        {{$helper.formatStatus(item.status).text}}
                    </v-chip>
                </template>
                <template v-slot:[`item.departmentName`]="{ item }">
                    <v-chip class="ma-2 caption font-weight-bold" color="teal darken-4" label text-color="white" >
                    <v-icon left>
                        mdi-store
                    </v-icon>
                    {{item.departmentName}}
                    </v-chip>
                </template>
                <template v-slot:[`item.confirmDate`]="{ item }" >
                    {{item.confirmDate}}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from '@/components/services/ApiServices';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import Export from './Export.vue';
import * as moment from "moment/moment";
import Create from './Create';

export default {
    name: "LeaveRequestCf",
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
        'data-export': Export,
        "create-dialog": Create,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                console.log(this.tableParams,"////////");
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                // this.fetchData();
            },
            deep: true,
        },
        month:{
            handler(val){
                this.tableParams.page=1;
                // Tính toán khoảng ngày theo tháng công (từ 26 tháng trước đến 25 tháng được chọn)
                const targetMonth = moment(val, "YYYY-MM");
                this.filters.from = targetMonth.clone().subtract(1, 'month').date(26).format("YYYY-MM-DD");
                this.filters.to = targetMonth.clone().date(25).format("YYYY-MM-DD");
                this.fetchData();
            }
        }
    },
    computed: {
        // params: function() {
        //     return {...this.tableParams, ...this.filters}
        // }
        pendingCount() {
            return this.items.filter((item) => item.status === 0).length;
        },
        confirmedCount() {
            return this.items.filter((item) => item.status === 1).length;
        },
        rejectedCount() {
            return this.items.filter((item) => item.status === 2).length;
        },
        totalCount() {
            return this.items.length;
        }
    },
    data () {
        // Tính toán tháng công hiện tại (bắt đầu từ ngày 26 tháng trước đến ngày 25 tháng này)
        const currentDate = moment();
        const defaultMonthVal = currentDate.date() > 25 
            ? currentDate.clone().add(1, 'month') 
            : currentDate.clone();
        const defaultMonthStr = defaultMonthVal.format("YYYY-MM");
        const defaultFrom = defaultMonthVal.clone().subtract(1, 'month').date(26).format("YYYY-MM-DD");
        const defaultTo = defaultMonthVal.clone().date(25).format("YYYY-MM-DD");

        return {
            ROOT_URL: "leaveRequests/",

            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize:50
            },
            month: defaultMonthStr,
            leavePlans:[],
            filters:{
                code: null,
                status: -1,
                employeeCode: null,
                employeeName: null,
                departmentCode: null,
                departmentName: null,
                leavePlanCode:null,
                leavePlanName: null,
                from: defaultFrom,
                to: defaultTo,
                leaveAmountType: -1,
                execDate: moment().format("YYYY-MM-DD")
            },
            departmentSearch:null,
            departments: [],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            exportDialog:false,
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            selectedItems: [],
            isBulkApproving: false,
            search:"",
            options: {},
            isLoading: true,

            dialog: {
                state: false,
                item: undefined,
            },
            item: null,
            dialogDelete: false,
            targetItem: undefined,

            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem'},
                { text: 'Mã', value: 'code', width: '5rem', 
                    filter: value => {
                    if (!this.filters.code) return true
                    return value.includes(this.filters.code)
                    },
                },
                { text: 'Trạng thái', align: 'start', value: 'status', sortable: true, width: '6rem',
                    filter: value => {
                    if (this.filters.status==-1) return true

                    return value == (this.filters.status)
                    },
                },
                { text: 'Phép', align: 'start', value: 'leaveAmountType', width: '5rem', 
                    filter: value => {
                    if (this.filters.leaveAmountType==-1) return true

                    return value == (this.filters.leaveAmountType)
                    },
                },
                { text: '', align: ' d-none', value: 'leavePlanCode',
                    filter: value => {
                    if (!this.filters.leavePlanCode) return true

                    return value == (this.filters.leavePlanCode)
                    },
                },
                { text: 'Loại', align: 'start', value: 'leavePlan', width: '12rem', 
                    filter: value => {
                    if (!this.filters.leavePlanName) return true

                    return value == (this.filters.leavePlanName)
                    },
                },
                { text: 'Nhân viên', align: 'start', value: 'employeeInfo', width: '10rem'},
                { text: '', align: ' d-none', value: 'employeeCode', 
                    filter: value => {
                    if (!this.filters.employeeCode) return true

                    return value.includes(this.filters.employeeCode)
                    },
                },
                { text: '', align: ' d-none', value: 'employeeName', 
                    filter: value => {
                    if (!this.filters.employeeName) return true

                    return value.toLowerCase().includes(this.filters.employeeName.toLowerCase())
                    },
                },
                { text: '', align: ' d-none', value: 'departmentCode', 
                    filter: value => {
                    if (!this.filters.departmentCode) return true

                    return value == (this.filters.departmentCode)
                    },
                },
                { text: 'Phòng ban', align: 'start', value: 'departmentName', width: '9rem', 
                    filter: value => {
                    if (!this.filters.departmentName) return true

                    return value.toLowerCase().includes(this.filters.departmentName.toLowerCase())
                    },
                },
                { text: 'Ngày áp dụng', align: 'start', value: 'from', width: '8rem',  
                    filter: value => {
                    if (!this.filters.from) return true

                    return value == (this.filters.from)
                    }
                },
                { text: 'Trạng thái xử lý', align: 'start', value: 'processInfo', width: '11rem'},
                { text: '', align: ' d-none', value: 'sentDate'},
                { text: 'Ghi chú', align: 'start', value: 'note', width: '10rem'},
                { text: '', align: ' d-none', value: 'confirmBy'},
                { text: '', align: ' d-none', value: 'confirmDate'},
            ],
            filterExpand: true
        }
    },
    methods: {
        closeHandler () {
            this.dialog = {state: false, item: undefined}
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatStatus(value){
            switch(value){
                case 0:{
                    return "Chờ duyệt";
                }
                case 1:{
                    return "Chấp nhận";
                }
                case 2:{
                    return "Từ chối";
                }
            }
        },
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchLeavePlan(){
            return ApiServices.fetchLeavePlan().then(res=>{
                this.leavePlans = res.data;
                console.log(this.leavePlans)
            })
        },
        fetchDepartment() {
            return http.get("departments/fetch", {
                // params: {
                //     search: this.departmentSearch
                // }
            }).then(res => {
                this.departments = res.data;
            })
        },
        fetchData () {
            this.isLoading = true;
            return http.get(this.ROOT_URL+'admin-mobile/', {
                params: {
                    month: this.month,
                    version: "2",
                    execDate: this.filters.execDate
                }
            })
            .then(res => {
                // console.log(res.data)
                console.log(res.data.data)
                this.items = res.data.data;
                // this.rowCount = res.data.rowCount;
            })
            .catch(err => {

            })
            .finally(() => {
                this.isLoading = false;
            })
        },
        
        accept(item) {
            http.get(this.ROOT_URL + "accept/" + item.code).then(res => {
                // let eventObj = {
                //     color: "success",
                //     message: "Cập nhật thành công",
                //     toast: true,
                // };
                // this.messageToast(eventObj);
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },
        
        bulkAccept() {
            if (this.selectedItems.length === 0) return;
            this.isBulkApproving = true;
            const itemsToApprove = this.selectedItems.filter(item => item.status === 0);
            
            let promise = Promise.resolve();
            itemsToApprove.forEach(item => {
                promise = promise.then(() => {
                    return http.get(this.ROOT_URL + "accept/" + item.code).catch(error => {
                        console.error("Error accepting item: " + item.code, error);
                    });
                });
            });
            
            promise.finally(() => {
                this.isBulkApproving = false;
                this.selectedItems = [];
                this.fetchData();
            });
        },

        decline(item) {
            http.get(this.ROOT_URL + "decline/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },

        undo(item) {
            http.get(this.ROOT_URL + "undo/" + item.code).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err)
            });
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL+"admin/"+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
    },
    created () {
        this.fetchData();
        this.fetchLeavePlan();
        this.fetchDepartment()
    }
}
</script>